export default __webpack_public_path__ + "static/media/settings.f5d3cb34.svg";